import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "GridEvent";
export const classes = {
  root: `${PREFIX}-root`,
};

export const GridEvent = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(90, 91, 144, 0.04)",
    },
  },
}));
